import { updateEmployeesBulkSessionByCsv } from "../../infrastructure/repository/employees-repository";
import { findCompanyId } from "../../infrastructure/repository/company-repository";
import { logError, addContextLog } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";
import { showErrorMessage } from "../commons/show-error-message";
import { displayEmployeesEditSummaryPage } from "./displays/display-employees-edit-summary";

export async function updateEmployeesByCsv({ employees }) {
  try {
    const companyId = await findCompanyId();
    const { data: updatedEmployees } = await updateEmployeesBulkSessionByCsv({
      companyId,
      employees,
    });

    addContextLog("info", "updateEmployeesByCsv", "request", { companyId });
    displayEmployeesEditSummaryPage({
      employees: updatedEmployees,
    });
  } catch (e) {
    logError(e, `Error to updateEmployeesByCsv`);
    showErrorMessage(translate("common-messages.basic-error-message"));
  }
}
